module.exports = __webpack_public_path__ + "ed68f6ede0040fc0946e9ee3773e8fb3.png";